/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import React from "react";
import SignInForm from "components/MainComponents/ExternalSignin/ExternalSigninForm";
import CommonNavigationBar from "components/MainComponents/NavigationBar/CommonNavigationBar";

export default function SignInPage() {
  const theme = useTheme();

  return (
    <>
      <div>
        <CommonNavigationBar />
        <SignInForm />
      </div>
    </>
  );
}
